import React, { useState, useEffect } from "react";
import "./wordsearch.css";
import { Replay } from "@mui/icons-material";

const wordsList = [
  "Conscience",
  "Hypothesis",
  "Tranquility",
  "Magnificent",
  "Perseverance",
  "Acknowledgment",
  "Questionnaire",
  "Architecture",
  "Kaleidoscope",
  "Entrepreneur",
  "Onomatopoeia",
  "Antediluvian",
  "Quixotic",
  "Phlegmatic",
  "Paraphernalia",
  "Sacrilegious",
  "Anachronistic",
  "Supercalifragilisticexpialidocious",
  "Cacophony",
];

const shuffleLetters = (word) => {
  return word.split("").sort(() => Math.random() - 0.5);
};

const WordSearch = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentWord, setCurrentWord] = useState(wordsList[0]);
  const [shuffled, setShuffled] = useState([]);
  const [selectedLetters, setSelectedLetters] = useState([]);
  const [message, setMessage] = useState([]);

  const loadWord = () => {
    const word = wordsList[currentIndex];
    setCurrentWord(word);
    setShuffled(shuffleLetters(word));
    setSelectedLetters(Array(word.length).fill("")); // empty slots
    setMessage("");
  };

  useEffect(() => {
    loadWord();
  }, [currentIndex]);

  const handleLetterClick = (letter, index) => {
    const nextEmptyIndex = selectedLetters.findIndex((val) => val === "");
    if (nextEmptyIndex !== -1) {
      const updated = [...selectedLetters];
      updated[nextEmptyIndex] = letter;
      setSelectedLetters(updated);
    }

    // Disable clicked button
    const newShuffled = [...shuffled];
    newShuffled[index] = null; // mark as used
    setShuffled(newShuffled);
  };

  const checkAnswer = () => {
    const userWord = selectedLetters.join("");
    const correctWord = currentWord;

    if (userWord === correctWord) {
      setMessage("🎉 Correct! Moving to next word...");
      setTimeout(() => {
        if (currentIndex < wordsList.length - 1) {
          setCurrentIndex(currentIndex + 1);
        } else {
          setMessage("✅ You finished all words!");
        }
      }, 1000);
    } else {
      setMessage("❌ Incorrect! Try Again.");
    }
  };

  const handleTryAgain = () => {
    setSelectedLetters(Array(currentWord.length).fill(""));
    setShuffled(shuffleLetters(currentWord));
    setMessage("");
  };

  return (
    <div className="wordsearch-background">
      <div className="spelling-container">
        <h2>Spell the Word</h2>
        <p style={{ color: "black" }}>
          Click letters to form the correct word:
        </p>

        {/* Display letter slots */}

        <div className="letters-container">
          {shuffled.map((letter, index) =>
            letter ? (
              <button
                key={index}
                className="letter-button"
                onClick={() => handleLetterClick(letter, index)}
              >
                {letter}
              </button>
            ) : (
              <button key={index} className="letter-button used" disabled>
                {/* Empty placeholder for used letters */}
              </button>
            )
          )}
        </div>
        <div className="letter-slots">
          {selectedLetters.map((letter, idx) => (
            <span key={idx} className="slot">
              {letter || "_"}
            </span>
          ))}
        </div>

        <div style={{ marginTop: "16px" }}>
          <button className="check-btn" onClick={checkAnswer}>
            Check Answer
          </button>

          <button
            className="try-again-btn"
            onClick={handleTryAgain}
            title="Try Again"
          >
            <Replay style={{ fontSize: "24px", color: "#374151" }} />
          </button>
        </div>

        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
};

export default WordSearch;
